import React from 'react';
import { CircularImageProps } from './CircularImage.types';
import * as S from './CircularImage.styles';

export const CircularImage = ({ src, size, ...props }: CircularImageProps) => {
  return <S.CircularImage src={src} size={size} {...props} />;
};
